import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { DISABLED_ANCHOR_CLASSES } from "./actionUtils"

const ActionButton = ({
  icon,
  iconStyle = "kit",
  label,
  href,
  disabled,
  danger,
  onClick,
}) => {
  const colorClass = danger ? "text-red-600" : "text-blue-700"

  if (href) {
    return (
      <a
        href={href}
        title={label}
        aria-label={label}
        className={classNames(
          "inline-flex items-center justify-center rounded-full bg-transparent p-1 text-lg no-underline",
          colorClass,
          { [DISABLED_ANCHOR_CLASSES]: disabled }
        )}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault()
          } else {
            onClick?.(e)
          }
        }}
      >
        <i className={`fa-${iconStyle} fa-${icon}`} />
      </a>
    )
  }

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={classNames(
        "inline-flex items-center justify-center rounded-full border-none bg-transparent p-1 text-lg",
        disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer",
        colorClass
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <i className={`fa-${iconStyle} fa-${icon}`} />
    </button>
  )
}

ActionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  iconStyle: PropTypes.string,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  onClick: PropTypes.func,
}

export default ActionButton
